// tileAlbedoUv.ts - the tile mesh's albedo uv formula, pure and node-loadable.
//
// Split out of createTileMesh (tileMesh.ts) so tools/preview/
// tile-decode-check.mjs can import the formula directly under Node, the way
// it already loads tileSource.ts and tileTree.ts, rather than a copy of it
// that could drift from what the mesh actually draws.
//
// A tile's albedo stores its row 0 at the v0 edge (imageBitmap.ts): a mesh
// grid fraction (a, b) in [0,1]^2, with (0, 0) at the tile's own (u0, v0)
// corner, samples texture space the same way - offset and scaled by the
// inherited ancestor's sub-rectangle, or the tile's own whole image at
// offset 0, scale 1.

import type { TileAlbedoRef } from './tileTree';

export function tileAlbedoUv(
  a: number,
  b: number,
  inherit: Pick<TileAlbedoRef, 'offsetU' | 'offsetV' | 'scale'> | null,
): readonly [number, number] {
  const scale = inherit ? inherit.scale : 1;
  const offsetU = inherit ? inherit.offsetU : 0;
  const offsetV = inherit ? inherit.offsetV : 0;
  return [offsetU + scale * a, offsetV + scale * b];
}
